import type { LocaleService } from '@blocksuite/affine-shared/services';

import { translateAIItemText } from '../../_common/locale';

const historyActionLocaleNames: Record<string, string> = {
  'Fix spelling for it': 'Fix spelling',
  'Improve grammar for it': 'Fix grammar',
  'Explain this': 'Explain selection',
  Translate: 'Translate to',
  'Change tone': 'Change tone to',
  'Improve writing for it': 'Improve writing',
  'Find action items from it': 'Find actions',
  Summary: 'Summarize',
  'Create headings': 'Generate headings',
  'Write outline': 'Generate outline',
  image: 'Generate an image',
  'Brainstorm mindmap': 'Brainstorm ideas with mind map',
  'Expand mind map': 'Expand mind map',
  'Create a presentation': 'Generate presentation',
  'Write a twitter about this': 'Write a tweet about this',
  'Make it real with text': 'Make it real with text',
  'AI image filter clay style': 'AI image filter: clay style',
  'AI image filter sketch style': 'AI image filter: sketch style',
  'AI image filter anime style': 'AI image filter: anime style',
  'AI image filter pixel style': 'AI image filter: pixel style',
  Clearer: 'Upscale image',
  'Remove background': 'Remove background',
  'Convert to sticker': 'Convert to sticker',
};

export function getChatActionLabel(
  locale: LocaleService | null | undefined,
  action: string
) {
  return translateAIItemText(
    locale,
    historyActionLocaleNames[action] ?? action
  );
}
